import { createApi } from '@reduxjs/toolkit/query/react'

import { baseQuery } from './index'

export const orderApi = createApi({
        baseQuery,
        reducerPath: 'orderApi',
        endpoints: (builder) => ({
            getOrdersCount: builder.query<any, void>({
                query: () => ({  url: `https://api.vedmarket.ru/calc-api/v4.0/order/stats/`})
                })
            }),
        });


export const { useLazyGetOrdersCountQuery } = orderApi
